/**
 * Created by Ning Jiang on 2021-05-27.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData, ReelState} from "../../../core/reel/ReelState";
import {Oktoberfest} from "../../Oktoberfest";
import {GameHelper} from "../../../core/utils/GameHelper";


export class OktoberfestNearWinController extends ReelStopPresentationController {

    protected _scatterCounter: number;
    private _spinStates: boolean[];

    constructor() {
        super('OktoberfestNearWinController');

    }

    public async start(): Promise<any> {
        this._spinStates = Oktoberfest.reels.map(reel => reel.reelState === ReelState.SPIN);
        await super.start();
    }

    protected onReelBounce(data: IReelStateEventData): Promise<any> {
        const scatterPosition = Oktoberfest.model.parsedGameData.scatterPositions![data.reelId];
        if (scatterPosition === -1) {
            return Promise.resolve();
        }
        if (!GameHelper.isFSMode()) {
            this._scatterCounter += 1; // To change if more scatter on the one reel.
        }
        return Promise.resolve();

    }

    protected onReelStopped(data: IReelStateEventData): Promise<void> {
        Oktoberfest.nearWinView.onReelSpinAnimationComplete({reelId: data.reelId});
        if (( data.reelId === 0 ) && Oktoberfest.model.parsedGameData.nearWinReels![data.reelId]) {
            return Promise.resolve(Oktoberfest.nearWinView.onPlayReelNearWinAttention(4));
        }
        const isNearWin = Oktoberfest.model.parsedGameData.nearWinReels![data.reelId + 1];
        if (isNearWin && !this.isSkip) {
            //when  reel 3 settls down //#681
            if (this._scatterCounter >= 2) {
                if (data.reelId === 3) {
                    Oktoberfest.model.reels.forEach((reels: string[], reelIndex: number) => {
                        if (data.reelId > reelIndex) {
                            reels.forEach((symName, symIndex) => {
                                if (symIndex <= 2) {
                                    const symbol = Oktoberfest.reels[reelIndex].getSymbol(symIndex);
                                    GameHelper.dimDownAllSymbols(symbol, "S");
                                }
                            });
                        }
                    });
                }
            }
            return Promise.resolve(this.playAnticipation(data.reelId));
        }
        if (data.reelId == 4) {
            Oktoberfest.partyMode.onAllReelsStopped();
            if (!( GameHelper.isReel4Stacked(Oktoberfest.model.parsedGameData.reels) && GameHelper.isReel2Stacked(Oktoberfest.model.parsedGameData.reels) )) {
                Oktoberfest.dimOverLay.onUndimStage(0.2);
                if (this._scatterCounter < 3) {
                    GameHelper.resetAllSymbols();
                } else if (this._scatterCounter > 2) {
                    Oktoberfest.model.reels[data.reelId].forEach((sym: string, symIndex: number) => {
                        if (symIndex <= 2) {
                            const symbol = Oktoberfest.reels[data.reelId].getSymbol(symIndex);
                            GameHelper.dimDownAllSymbols(symbol, "S");
                        }
                    });
                }
            }
        }

        return super.onReelStopped(data);
    }

    protected reset() {
        super.reset();
        this._scatterCounter = 0;
    }

    private playAnticipation(reelId: number): void {
        if (reelId == 3 && this._scatterCounter >= 2) {
            Oktoberfest.model.reels[reelId].forEach((sym: string, symIndex: number) => {
                if (symIndex <= 2) {
                    const symbol = Oktoberfest.reels[reelId].getSymbol(symIndex);
                    GameHelper.dimDownAllSymbols(symbol, "S");
                }
            });
        }
        Oktoberfest.nearWinView.onPlayReelNearWinAttention(reelId + 1);
    }
}